import PropTypes from "prop-types";
import { Checkbox } from "semantic-ui-react";

import ValidatedField from "./ValidatedField";
import styles from "./CheckboxField.module.scss";

function CheckboxField(props) {
  const {
    value,
    propertyName,
    setFieldValue,
    handleChange,
    label,
    errors,
    touched,
    toggle,
    disabled,
    withoutErrorMessage,
    shouldValidate,
    fieldClassName,
    testId,
    isReadOnlyView,
  } = props;

  const onChange = async (e, target) => {
    await setFieldValue(target.id, target.checked, shouldValidate);
    handleChange?.(e);
  };

  if (isReadOnlyView) {
    return (
      <div className={styles.readOnlyWrapper}>
        <span>{label}</span>
      </div>
    );
  }

  return (
    <ValidatedField
      propertyName={propertyName}
      errors={errors}
      touched={touched}
      withoutErrorMessage={withoutErrorMessage}
      className={fieldClassName}
    >
      <Checkbox
        id={propertyName}
        type="checkbox"
        checked={value}
        onChange={onChange}
        label={label}
        toggle={toggle}
        disabled={disabled}
        data-testid={testId}
      />
    </ValidatedField>
  );
}

CheckboxField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  propertyName: PropTypes.string.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,
  handleChange: PropTypes.func,
  toggle: PropTypes.bool,
  disabled: PropTypes.bool,
  withoutErrorMessage: PropTypes.bool,
  setFieldValue: PropTypes.func,
  fieldClassName: PropTypes.string,
  testId: PropTypes.string,
  isReadOnlyView: PropTypes.bool,
};

export default CheckboxField;
